import { render, staticRenderFns } from "./SystemAccountInvitationBtn.vue?vue&type=template&id=373e533e&scoped=true&"
import script from "./SystemAccountInvitationBtn.vue?vue&type=script&lang=js&"
export * from "./SystemAccountInvitationBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373e533e",
  null
  
)

export default component.exports